import { mutations } from './mutations';
import { getters } from './getters';
import { 
    dispatchCreateUploadImageList,
    dispatchGetOmrTaskList,
    dispatchGetDealEvent,
    dispatchGetXmlScore,
    dispatchGetUploadImageList,
} from './actions';
import { OmrState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


const { commit, read } = getStoreAccessors<OmrState, State>('');
// commit
export const commitSetImgList = commit(mutations.setImgList);
export const commitSetScoreName = commit(mutations.setScoreName);
export const commitAutoShowStatementDialog = commit(mutations.setAutoShowStatementDialog);
// read
export const readUploadImageState = read(getters.uploadImageState);
export const readUploadImageList = read(getters.uploadImageList);
export const readAutoShowStatementDialog = read(getters.autoShowStatementDialog);
// dispatch
export { 
    dispatchCreateUploadImageList,
    dispatchGetOmrTaskList,
    dispatchGetDealEvent,
    dispatchGetXmlScore,
    dispatchGetUploadImageList,
};
